import {mixins} from "../app/mixin";

var companies = window.companies;

mixins.push({
    el: '.referencesWrapper',
    data: () => ({
        companies: companies,
        mainCategory: 0,
        letters: 'ABCDEFGHIJKLMNOPRSTUVYZ',
        mobileLetters: ['ABCDEFGH', 'IJKLMNOP', 'RSTUVYZ'],
        searchQuery: '',
        letterFilter: '',
        references: {
            left: [],
            middle: [],
            right: [],
        },
        referenceToShown: [],
        isLoading: false,
        referenceList: [],
        showNoResult: false,
    }),
    methods: {
        toggleCardExpand(index) {
            this.companies[index][1] = !this.companies[index][1];
        },
        openReports(index, categoryIndex) {
            this.companies[index][2][categoryIndex] = !this.companies[index][2][categoryIndex];
        },
        setFilterLetter(letter) {
            this.searchQuery = '';
            let showNoResult = true;

            if (letter === this.letterFilter) {
                letter = '';
            }

            if (letter === '') {
                for (let company of this.companies) {
                    company[5] = false;
                }

                showNoResult = false;
            } else {
                for (let company of this.companies) {
                    company[5] = !letter.includes(company[4]);

                    if (showNoResult && !company[5]) {
                        showNoResult = false;
                    }
                }
            }

            this.letterFilter = letter;
            this.showNoResult = showNoResult;
        },
        searchFilterChange() {
            if (this.searchQuery === '') {
                this.setFilterLetter(this.letterFilter);
            } else {
                let showNoResult = true;

                for (let company of this.companies) {
                    company[5] = !company[3].toLowerCase().includes(this.searchQuery);

                    if (showNoResult && !company[5]) {
                        showNoResult = false;
                    }
                }

                this.showNoResult = showNoResult;
            }
        }
    },
});